'use strict';

if (!customElements.get('product-bundle')) {
  customElements.define(
    'product-bundle',
    class ProductBundle extends HTMLElement {
      constructor() {
        super();
        this.productIds = [];
        this.notification = this.dataset.notification;

        this.CartDrawerNotification = document.querySelector('cart-notification');
        this.CartDrawer = document.querySelector('cart-drawer');
      }

      connectedCallback() {
        this.updateProductId();

        this.elements = {
          error: this.querySelector('[data-component="product-bundle-error"]')
        };

        this.initCheckboxListeners();
        this.addEventListener('click', (event) => this.handleButtonClick(event));
      }

      parsePrice(priceString) {
        const cleaned = priceString.replace(/[^\d.,-]/g, '');

        const lastDot = cleaned.lastIndexOf('.');
        const lastComma = cleaned.lastIndexOf(',');

        let normalized = cleaned;

        if (lastDot > -1 && lastComma > -1) {
          if (lastDot > lastComma) {
            normalized = cleaned.replace(/,/g, '');
          } else {
            normalized = cleaned.replace(/\./g, '').replace(',', '.');
          }
        } else if (lastComma > -1) {
          normalized = cleaned.replace(',', '.');
        } else {
          normalized = cleaned;
        }

        const value = parseFloat(normalized);
        return isNaN(value) ? 0 : value;
      }

      initCheckboxListeners() {
        const checkboxesStatus = this.querySelectorAll('.bundle-input, fieldset input');
        const bundleTotalPrice = this.querySelector('.bundle-total__price');

        checkboxesStatus.forEach((checkbox) => {
          checkbox.addEventListener('change', () => {
            setTimeout(() => {
              let totalPrice = 0;
              
              const currency = bundleTotalPrice.dataset.currency || '';
              const currencyCode = bundleTotalPrice.dataset.currencyCode || '';
        
              const bundleProducts = this.querySelectorAll('.card__information');
              bundleProducts.forEach((bundleProduct) => {
                const checkbox = bundleProduct.querySelector('.bundle-input:checked');
                if (checkbox) {
                  const priceElement = bundleProduct.querySelector('.original-price');
                  if (priceElement) {
                    const priceText = priceElement.textContent?.trim() || '';
                    
                    const price = this.parsePrice(priceText);
                    if (price > 0) {
                      totalPrice += price;
                    }
                  }
                }
              });
        
              const formattedTotal = totalPrice.toFixed(2);
              bundleTotalPrice.textContent = `${currency}${formattedTotal}${currencyCode}`;
            }, 100);
          });
        });
      }

      checkTargetELement(element, selector) {
        let targetEl = null;
        if (element.matches(`${selector}`) || element.closest(`${selector}`)) {
          targetEl = element
        }
        return targetEl
      }

      handleButtonClick(event) {
        const submitButton = this.checkTargetELement(event.target, '.bundle-button');
        if (submitButton) {
          if (this.CartDrawer) {
            submitButton.setAttribute('aria-haspopup', 'dialog');
          }
          this.addBundleToCart(submitButton);
        }
      }

      updateProductId() {
        const checkboxes = this.querySelectorAll('.bundle-input');
        this.productIds = [];
        this.productIds = Array.from(checkboxes).filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);
      }

      async addBundleToCart(button) {
        if (!button) return;

        this.updateProductId();
        button.setAttribute('disable', 'true');

        const bundleProducts = this.productIds.map((id) => {
          const prodId = +id;
          return {
            id: prodId,
            quantity: 1, 
          }
        });

        const bundleData = {
          items: bundleProducts
        }

        try {
          const response = await fetch(window.routes.cart_url + '/add.js', {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify(bundleData),
          });

          if (!response.ok) {
            throw new Error(`${window.cartStrings.error}`);
          } else {
            if(this.CartDrawer) {
              // Ensure focus returns to the triggering button after drawer closes
              if (typeof this.CartDrawer.setActiveElement === 'function') {
                this.CartDrawer.setActiveElement(button);
              }
              fetch(`${routes.shopUrl}`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const selectors = ['cart-drawer-items', '.drawer__footer', '#cart-icon-bubble .cart-count-bubble', '#cart-icon-bubble-sticky .cart-count-bubble'];
                  for (const selector of selectors) {
                    const targetElement = document.querySelector(selector);
                    const sourceElement = html.querySelector(selector);
                  
                    if (targetElement && sourceElement) {
                      targetElement.replaceWith(sourceElement);
                    }
                  }
                })

              this.CartDrawer.classList.remove('is-empty');
              let cartDrawerEmpty = this.CartDrawer.querySelector('.drawer__inner-empty');
              if (cartDrawerEmpty) {
                cartDrawerEmpty.remove();
              }
              this.CartDrawer.open();
            }

            button.removeAttribute('available', 'true');
          }
        
        } catch (error) {
          this.showMessage(error.message);
        }
      }

      showMessage(message) {
        if (this.elements.error) {
          this.elements.error.textContent = message;
          this.elements.error.classList.add('visible');
        }
      }
    }
  );
}


if (!customElements.get('variant-selects-bundle')) {
  customElements.define(
    'variant-selects-bundle',
    class VariantSelectsBundle extends HTMLElement {
      constructor() {
        super();
        this.variants = [];
      }

      connectedCallback() {
        this.variants = this.getVariants();
        this.markIfMultipleFieldsets();
        this.addEventListener('change', this.handleVariantChange.bind(this));
      }

      handleVariantChange(event) {

        this.deselectOtherInputs(event.target);

        const selectedOptionValues = this.selectedOptionValues;
        const matchingVariant = this.findMatchingVariant(selectedOptionValues);

        const parentWrapper = this.closest('.card-variants-wrapp');
        const bundleInput = parentWrapper?.querySelector('.bundle-input');


        if (matchingVariant) {
          this.updateSelectedVariant(matchingVariant.id);
          this.updatePrice(matchingVariant.price, matchingVariant.comparePrice);
          this.updateImage(matchingVariant.featured_image);
      
          if (bundleInput) {
            bundleInput.checked = matchingVariant.available;
            if (matchingVariant.available) {
              bundleInput.removeAttribute('disabled');
            } else {
              bundleInput.setAttribute('disabled', 'true');
            }
          }
        } else {
          this.updateSelectedVariant('');
          this.updatePrice(null, null);
      
          if (bundleInput) {
            bundleInput.checked = false;
            bundleInput.setAttribute('disabled', 'true');
          }
        }

        this.updateAvailableOptions(event.target);
      }

      deselectOtherInputs(selectedInput) {
        const fieldset = selectedInput.closest('fieldset');
        if (fieldset) {
          const inputs = fieldset.querySelectorAll('input');
          inputs.forEach(input => {
            if (input !== selectedInput) {
              input.removeAttribute('checked');
            }
          });
        }
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getVariants() {
        const variantsScript = this.querySelector('script[data-variants]');
        if (variantsScript) {
          return JSON.parse(variantsScript.innerText);
        } else {
          return [];
        }
      }

      markIfMultipleFieldsets() {
        const fieldsets = this.querySelectorAll('fieldset');
        if (fieldsets.length > 1) {
          fieldsets[0].classList.add('not-only-variant');
        }
      }

      findMatchingVariant(selectedOptions) {
        return this.variants.find((variant) =>
          selectedOptions.every(
            (value, index) => variant.options[index] === value
          )
        );
      }

      updateAvailableOptions(selectedInput) {
        const selectedOptionValues = this.selectedOptionValues;
        const fieldsets = this.querySelectorAll('fieldset');
      
        fieldsets.forEach((fieldset, fieldsetIndex) => {
          if (fieldset.contains(selectedInput)) return;
      
          const inputs = fieldset.querySelectorAll('input');
          
          inputs.forEach(input => {
            const optionValueId = input.dataset.optionValueId;
      
            const isOptionAvailable = this.variants.some(variant => {
              if (!variant.available) return false;
              
              if (variant.options[fieldsetIndex] !== optionValueId) return false;
              
              return selectedOptionValues.every((selectedValue, selectedIndex) => {
                if (selectedIndex === fieldsetIndex) return true;
                
                return variant.options[selectedIndex] === selectedValue;
              });
            });
      
            if (isOptionAvailable) {
              input.classList.remove('disabled');
              if (input.classList.contains('swatch-input__input')) {
                input.classList.remove('visually-disabled');
              }
            } else {
              input.classList.add('disabled');
              if (input.classList.contains('swatch-input__input')) {
                input.classList.add('visually-disabled');
              }
            }
          });
        });
      }

      updateSelectedVariant(variantId) {
        const parentWrapper = this.closest('.card-variants-wrapp');
        if (parentWrapper) {
          const bundleInput = parentWrapper.querySelector('.bundle-input');
          if (bundleInput) {
            bundleInput.value = variantId;
          }
        }
      }

      updatePrice(price, comparePrice) {
        const parentWrapper = this.closest('.product-bundles__item');
        const priceElementRegular = parentWrapper.querySelector('.price__regular .price-item.price-item--regular');
        const priceElementSale = parentWrapper.querySelector('.price__sale .price-item.price-item--sale');
        const priceElementSaleCompare = parentWrapper.querySelector('.price__sale .price-item.price-item--regular');
        if (priceElementRegular) {
          priceElementRegular.textContent = price;
        }
        if (priceElementSale) {
          priceElementSale.textContent = price;
          priceElementSaleCompare.textContent = comparePrice;
        }
      }

      updateImage(imageUrl) {
        if (imageUrl != false) {
          const parentWrapper = this.closest('.product-bundles__item');
          const imageElement = parentWrapper.querySelector('.card__media img');
          if (imageElement) {
            imageElement.src = imageUrl;
          }
        }
      }
    }
  );
}



(function () {
  const productBundlesContainer = document.querySelector('.product-bundles__container');

  if (productBundlesContainer) {
    const paginationItems = productBundlesContainer.querySelectorAll('.media-list-pagination-item');
    if (!paginationItems.length) return;

    const mediaItems = productBundlesContainer.querySelectorAll('.product-bundles__media-item');
    const mediaScrollContainer = mediaItems[0]?.parentElement;

    const activatePaginationItem = (item, index) => {
      if (!item) return;
      const paginationIndex = item.getAttribute('data-slide-index');

      productBundlesContainer
        .querySelectorAll('[data-slide-index^="child-group-"]')
        .forEach(el => el.classList.remove('active'));

      productBundlesContainer
        .querySelectorAll(`[data-slide-index="child-${paginationIndex}"]`)
        .forEach(el => el.classList.add('active'));

      paginationItems.forEach(p => {
        p.classList.remove('active');
      });
      item.classList.add('active');

      const targetMediaItem = mediaItems[index];
      if (targetMediaItem) {
        targetMediaItem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }
    };

    paginationItems.forEach((item, index) => {
      if (!item.hasAttribute('tabindex')) item.setAttribute('tabindex', '0');

      item.addEventListener('click', () => {
        activatePaginationItem(item, index);
      });

      item.addEventListener('keydown', (event) => {
        const isEnter = event.key === 'Enter';
        const isSpace = event.key === ' ' || event.key === 'Spacebar';
        if (isEnter || isSpace) {
          event.preventDefault();
          activatePaginationItem(item, index);
        }
      });
    });

    if (mediaScrollContainer) {
      const observerOptions = {
        root: mediaScrollContainer,
        threshold: 0.6
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = [...mediaItems].indexOf(entry.target);
            if (index === -1) return;

            paginationItems.forEach(p => {
              p.classList.remove('active');
            });
            const activePagination = paginationItems[index];
            activePagination?.classList.add('active');

            const indexAttr = activePagination?.getAttribute('data-slide-index');

            productBundlesContainer.querySelectorAll('[data-slide-index^="child-group-"]')
              .forEach(el => el.classList.remove('active'));

            productBundlesContainer.querySelectorAll(`[data-slide-index="child-${indexAttr}"]`)
              .forEach(el => el.classList.add('active'));
          }
        });
      }, observerOptions);

      mediaItems.forEach(item => observer.observe(item));
    }
  }

  const productBundlesHotpotContainer = document.querySelector('.bundles__grid-hotspot');
  if (!productBundlesHotpotContainer) return;

  const handleHotspotActivation = (item) => {
    if (!item) return;
    const index = item.getAttribute('data-index');

    productBundlesHotpotContainer.querySelectorAll('.product-bundles__item.active')
      .forEach(el => el.classList.remove('active'));

    const target = productBundlesHotpotContainer.querySelector(`.product-bundles__item[data-index="${index}"]`);
    if (!target) return;

    target.classList.add('active');

    if (window.innerWidth < 1025) {
      const parent = target.parentElement;
      parent.insertBefore(target, parent.firstChild);
    }
  };

  productBundlesHotpotContainer.addEventListener('mouseover', (event) => {
    if (window.innerWidth >= 1025) {
      const item = event.target.closest('.bundles-hotspot-item');
      handleHotspotActivation(item);
    }
  });

  productBundlesHotpotContainer.addEventListener('mouseout', (event) => {
    if (window.innerWidth >= 1025) {
      const item = event.target.closest('.bundles-hotspot-item');
      const index = item?.getAttribute('data-index');
      const target = productBundlesHotpotContainer.querySelector(`.product-bundles__item[data-index="${index}"]`);
      if (target) target.classList.remove('active');
    }
  });

  ['click', 'touchstart'].forEach(evt => {
    productBundlesHotpotContainer.addEventListener(evt, (event) => {
      if (window.innerWidth < 1025) {
        const item = event.target.closest('.bundles-hotspot-item');
        handleHotspotActivation(item);
      }
    });
  });
})();

